(() => {
  const records = [
    {
      id: 'CKC-KA-1396',
      title: 'CHA SKYLOOP 40 Product DNA and Operating Scope',
      handle: 'cha-skyloop-40-product-dna',
      quick: 'The CHA SKYLOOP 40 is a 141 ft horizontal full-wave loop designed for 40 and 20 meters without a tuner and 17, 15, 12, and 10 meters with a suitable tuner.',
      summary: 'Understand the CHA SKYLOOP 40 architecture, supported bands, power limits, site requirements, operating roles, and selection boundaries before planning an installation.',
      category: 'Product Installation Guides',
      section: 'CHA SKYLOOP 40',
      keywords: 'CHA SKYLOOP 40, Skyloop 40, horizontal full-wave loop, 40 meter loop, 20 meter loop, NVIS, HOA antenna, base station, shortwave listening, loop antenna, Product DNA',
      seoTitle: 'CHA SKYLOOP 40 Product DNA and Operating Scope | CKB',
      metaDescription: 'Learn the CHA SKYLOOP 40 architecture, no-tuner bands, tuner-supported bands, power limits, footprint, height, and operating roles.',
      difficulty: 'Beginner to Intermediate',
      readingTime: '7-9 min',
      revision: '1.0',
      reviewed: '2026-07-20',
      url: '/pages/chameleon-knowledge-base?article=cha-skyloop-40-product-dna',
      published: true,
      canonicalHandle: 'cha-skyloop-40-product-dna',
      canonicalId: 'CKC-KA-1396',
      editorialStatus: 'source_governed',
      bodyChunk: '27',
      relatedHeadings: ['Quick Answer', 'What the System Is', 'Supported Operating Scope', 'Where It Fits', 'Selection Boundaries', 'Source and Freshness Note'],
      sourceReviewed: '2026-07-20',
      sourceAuthority: 'Official CHA SKYLOOP 40 User Guide, Quick Start Guide, and Flysheet revision 2026-07-16',
      freshnessPolicy: 'Review after a product-page, guide, included-component, rating, compatibility, safety, or lifecycle change.'
    },
    {
      id: 'CKC-KA-1397',
      title: 'CHA SKYLOOP 40 Installation and Support Planning',
      handle: 'cha-skyloop-40-installation-and-support-planning',
      quick: 'Plan four safe support points around a 141 ft closed loop, preserve the total wire length, protect the feedpoint from strain, and analyze the completed geometry before transmitting.',
      summary: 'Use a controlled site-planning and installation sequence for the CHA SKYLOOP 40, including side lengths, support choices, height, feed-line routing, weatherproofing, and final verification.',
      category: 'Product Installation Guides',
      section: 'CHA SKYLOOP 40',
      keywords: 'CHA SKYLOOP 40 installation, 141 foot loop, 35.25 foot sides, 36 foot loop, four supports, PORTA-MAST, trees, fence, eaves, paracord, coax, small lot, HOA',
      seoTitle: 'CHA SKYLOOP 40 Installation and Support Planning | CKB',
      metaDescription: 'Plan and install the CHA SKYLOOP 40 using safe supports, a controlled 141 ft loop, correct strain relief, coax routing, and analyzer verification.',
      difficulty: 'Intermediate',
      readingTime: '9-11 min',
      revision: '1.0',
      reviewed: '2026-07-20',
      url: '/pages/chameleon-knowledge-base?article=cha-skyloop-40-installation-and-support-planning',
      published: true,
      canonicalHandle: 'cha-skyloop-40-installation-and-support-planning',
      canonicalId: 'CKC-KA-1397',
      editorialStatus: 'source_governed',
      bodyChunk: '27',
      relatedHeadings: ['Quick Answer', 'Site Planning', 'Controlled Installation Sequence', 'Geometry and Height', 'Pre-Transmit Checklist', 'Safety and Stop-Work Conditions', 'Source and Freshness Note'],
      sourceReviewed: '2026-07-20',
      sourceAuthority: 'Official CHA SKYLOOP 40 User Guide and Quick Start Guide revision 2026-07-16',
      freshnessPolicy: 'Review after a product-page, guide, included-component, rating, compatibility, safety, or lifecycle change.'
    },
    {
      id: 'CKC-KA-1398',
      title: 'CHA SKYLOOP 40 Tuning, SWR, and Troubleshooting',
      handle: 'cha-skyloop-40-tuning-swr-and-troubleshooting',
      quick: 'Measure the installed loop first, leave it unchanged when both 40 m band edges are at or below 2.0:1, and trim only in small documented steps after ruling out connection and feed-line faults.',
      summary: 'Diagnose and tune the CHA SKYLOOP 40 safely using the manual’s 40 m band-edge test, careful end-strip trimming procedure, and systematic coax and connection checks.',
      category: 'Maintenance & Repair',
      section: 'CHA SKYLOOP 40',
      keywords: 'CHA SKYLOOP 40 tuning, SWR, resonance, trim loop wire, 60 kHz per foot, 7.0 MHz, 7.3 MHz, analyzer, coax fault, troubleshooting, maintenance',
      seoTitle: 'CHA SKYLOOP 40 Tuning, SWR, and Troubleshooting | CKB',
      metaDescription: 'Measure, tune, and troubleshoot the CHA SKYLOOP 40 with the official band-edge test, careful trimming method, and systematic connection checks.',
      difficulty: 'Intermediate',
      readingTime: '8-10 min',
      revision: '1.0',
      reviewed: '2026-07-20',
      url: '/pages/chameleon-knowledge-base?article=cha-skyloop-40-tuning-swr-and-troubleshooting',
      published: true,
      canonicalHandle: 'cha-skyloop-40-tuning-swr-and-troubleshooting',
      canonicalId: 'CKC-KA-1398',
      editorialStatus: 'source_governed',
      bodyChunk: '27',
      relatedHeadings: ['Quick Answer', 'Establish a Baseline', 'Decision Rule Before Trimming', 'Controlled Trimming Procedure', 'Troubleshooting Sequence', 'What the Result Means', 'Safety and Stop-Work Conditions', 'Source and Freshness Note'],
      sourceReviewed: '2026-07-20',
      sourceAuthority: 'Official CHA SKYLOOP 40 User Guide revision 2026-07-16',
      freshnessPolicy: 'Review after a product-page, guide, included-component, rating, compatibility, safety, or lifecycle change.'
    },
    {
      id: 'CKC-KA-1400',
      title: 'CHA SKYLOOP 40 Modeled Radiation Patterns and Operating Strategy',
      handle: 'cha-skyloop-40-modeled-radiation-patterns',
      quick: 'At 30 ft over Real Ground, the supplied model transitions from broad, high-angle lower-band coverage to directional upper-band lobes and reports up to 11.4 dBi maximum gain on 10 meters in favored directions.',
      summary: 'Read the seven-band EZNEC results, understand how pattern and modeled maximum gain change from 40 through 10 meters, plan loop orientation, and use only technically supported performance claims.',
      category: 'Antenna Theory',
      section: 'CHA SKYLOOP 40',
      keywords: 'CHA SKYLOOP 40 radiation pattern, EZNEC, 30 feet, Real Ground, modeled gain, 6.7 dBi, 9.4 dBi, 10.9 dBi, 10.8 dBi, 11.4 dBi, horizontal loop, NVIS, DX lobes, azimuth, elevation, antenna orientation',
      seoTitle: 'CHA SKYLOOP 40 Radiation Patterns and Modeled Gain | CKB',
      metaDescription: 'Explore seven-band CHA SKYLOOP 40 EZNEC patterns at 30 ft over Real Ground, including modeled maximum gain up to 11.4 dBi on 10 meters.',
      difficulty: 'Intermediate',
      readingTime: '12-15 min',
      revision: '1.0',
      reviewed: '2026-07-21',
      url: '/pages/chameleon-knowledge-base?article=cha-skyloop-40-modeled-radiation-patterns',
      published: true,
      canonicalHandle: 'cha-skyloop-40-modeled-radiation-patterns',
      canonicalId: 'CKC-KA-1400',
      editorialStatus: 'source_governed',
      bodyChunk: '27',
      relatedHeadings: ['Quick Answer', 'What the Model Does - and Does Not - Establish', 'Seven-Band Results', 'Why the Pattern Changes', 'Band-by-Band Operating Strategy', 'Orientation and Commissioning', 'Claims That Are Supported', 'Claims That Are Not Yet Supported', 'Source and Freshness Note'],
      sourceReviewed: '2026-07-21',
      sourceAuthority: 'Official CHA SKYLOOP 40 manual revision 2026-07-16, supplied EZNEC Pro/2+ model plots, ARRL horizontal-loop engineering, and Sevick transformer context',
      freshnessPolicy: 'Review after an antenna-geometry, matching-network, model-file, model-assumption, documented-band, rating, installation, or field-validation change.'
    }
  ];

  window.CKB_SEARCH_INDEX = Array.isArray(window.CKB_SEARCH_INDEX) ? window.CKB_SEARCH_INDEX : [];
  const handles = new Set(window.CKB_SEARCH_INDEX.map(record => record.handle));
  records.forEach(record => {
    if (!handles.has(record.handle)) window.CKB_SEARCH_INDEX.push(record);
  });
})();
